module.exports = __webpack_public_path__ + "static/media/Group2701.f87a061a.svg";